import React from 'react'
import PropTypes from 'prop-types';
import {Paragraph} from '@aaa/muse-ds'
export default function CompletionComponent(props){

    return <Paragraph>
        Hello {props.memberName}! Your AAA Premier membership has been validated. You will receive an email from Hertz once Hertz verifies and upgrades your Gold Plus Rewards account to 5-star!
    </Paragraph>
}

CompletionComponent.propTypes={
    memberName: PropTypes.string
}